import React from 'react';
import { ProductReview } from '../types';
import StarRating from './StarRating';

interface ReviewProps {
  review: ProductReview;
}

type Props = React.FC<React.HTMLProps<HTMLDivElement> & ReviewProps>;

const Review: Props = ({ className, children, review, ...props }) => {
  return (
    <div {...props} className={`space-y-16 py-32 ${className ? className : ''}`}>
      <StarRating rating={review.score} />

      <div>
        <h4 className="text-h4"> {review.reviewer} </h4>

        <p>{new Date(review.createdAt).toDateString()}</p>
      </div>

      <p>{review.content}</p>
    </div>
  );
};

export default Review;
